module.exports = __webpack_public_path__ + "static/media/soundAttemption.9270f6f1.mp3";